import React from "react";
import NetworkMapComponent from "./NetworkMapComponent";
import { Helmet } from "react-helmet-async";

export default function NetworkMapPage() {
    return (



        <>
            <Helmet>
                <title>Network | Sec1 Software Pvt. Ltd.</title>
            </Helmet>

            <div id="kt_app_toolbar" className="app-toolbar pt-12 rounded-0">
                <div
                    id="kt_app_toolbar_container"
                    className="app-container container-fluid d-flex align-items-stretch"
                >
                    <div className="app-toolbar-wrapper d-flex flex-stack flex-wrap gap-4 w-100">
                        <div className="page-title d-flex flex-column gap-1 me-3 mb-2">
                            <h1 className="page-heading d-flex flex-column justify-content-center text-dark fw-bolder fs-1 lh-0">
                                Network
                            </h1>
                        </div>
                    </div>
                </div>
            </div>

            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div
                    id="kt_app_content_container"
                    className="app-container container-fluid"
                >
                    <div className="mb-3">

                        {/* <div className="card mt-5"> */}
                            {/* <div className="card-body p-4"> */}
                                <NetworkMapComponent />
                            {/* </div> */}
                        {/* </div> */}

                    </div>

                </div>
            </div>

        </>




    );
}
